import React, { useState, useEffect, useRef } from 'react';
import SearchFieldsSelect, { useSearchFields, getSearchFieldsPlaceholder } from '../../Components/SearchFieldsSelect/SearchFieldsSelect';
import { Table, Button, Avatar, Tag, Typography, Input, Select, DatePicker, Space, Row, Col, Card, Tooltip, Badge, message, Modal, Divider, Pagination, Statistic } from 'antd';
import { 
  UserOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  CarOutlined, 
  TagOutlined, 
  EyeOutlined,
  SearchOutlined,
  ReloadOutlined,
  FilterOutlined,
  CalendarOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  ClockCircleOutlined,
  CopyOutlined,
  FileTextOutlined,
  EnvironmentOutlined,
  DollarCircleOutlined,
  ShopOutlined,
  CreditCardOutlined,
  RiseOutlined,
  FallOutlined,
  ClearOutlined,
  TeamOutlined,
  TruckOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  CommentOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  HistoryOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import API from '../../API/API';
import dayjs from 'dayjs';
import { motion } from 'framer-motion';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import { YardTab, YardModal } from '../LeadDetails/LeadDetails';
import YardReassignmentHistoryModal from '../../Components/YardReassignmentHistory/YardReassignmentHistoryModal';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

const { Text, Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const toPST = (date) => {
    if (!date) return null;
    return dayjs(date).tz('America/Los_Angeles');
};

const getShipmentDeliveredDate = (record) => {
  const deliveredHistory = Array.isArray(record?.ShipmentTrackingHistory)
    ? record.ShipmentTrackingHistory
        .filter(
          (entry) =>
            entry?.field === 'ShipmentTracking.deliveryStatus' &&
            entry?.newValue === 'Delivered' &&
            entry?.changedAt
        )
        .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))
    : [];

  if (deliveredHistory.length > 0) {
    return deliveredHistory[0].changedAt;
  }

  if (record?.ShipmentTracking?.deliveryStatus === 'Delivered' && record?.ShipmentTrackingUpdatedAt) {
    return record.ShipmentTrackingUpdatedAt;
  }

  return null;
};

const OrderComplete = () => {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);
  
  // Agent filter state
  const [agents, setAgents] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [loginAgent, setLoginAgent] = useState({});
  
  // Yard details state
  const [yardDetailsMap, setYardDetailsMap] = useState({});
  const [selectedYard, setSelectedYard] = useState(null);
  const [yardModalVisible, setYardModalVisible] = useState(false);
  const [selectedLeadForYard, setSelectedLeadForYard] = useState(null);
  const [yardHistoryLead, setYardHistoryLead] = useState(null);
  const [editingRelocateStatus, setEditingRelocateStatus] = useState(false);
const [editingRelocateValue, setEditingRelocateValue] = useState('');
const [editingRelocateDate, setEditingRelocateDate] = useState(null);
  // Edit states for both statuses
  const [editingId, setEditingId] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const [serviceAgentsMap, setServiceAgentsMap] = useState({});
const [loadingServiceAgents, setLoadingServiceAgents] = useState(false);
const [selectedServiceAgentId, setSelectedServiceAgentId] = useState(null);
// Add these with your other state declarations
const [serviceAgentModalVisible, setServiceAgentModalVisible] = useState(false);
const [selectedLeadForServiceAgent, setSelectedLeadForServiceAgent] = useState(null);
const [selectedServiceAgentForLead, setSelectedServiceAgentForLead] = useState(null);
const [savingServiceAgent, setSavingServiceAgent] = useState(false);
const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return dayjs(dateString).format('MM-DD-YYYY hh:mm A');
};
  const [sortedInfo, setSortedInfo] = useState({
    field: 'updatedAt',
    order: 'descend',
  });
  const [filteredInfo, setFilteredInfo] = useState({
    part: null,
    invoiceStatus: null,
    purchaseOrderStatus: null,
    agent: null,
  });
  
  // Search and filter states
  const [searchText, setSearchText] = useState('');
  // The search a request uses: the box's text, set 0.5 s after typing pauses
  // (at once when the box is cleared), so a search is not sent per keystroke.
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    const trimmed = searchText.trim();
    if (!trimmed) {
      setSearchQuery('');
      return undefined;
    }
    const timer = setTimeout(() => setSearchQuery(trimmed), 500);
    return () => clearTimeout(timer);
  }, [searchText]);
  const [searchFields, setSearchFields] = useSearchFields('order-complete:search-fields');
  // The "Search in" group only changes the results of a search, so changing it
  // with an empty search box sends no request.
  const effectiveSearchFields = searchQuery ? searchFields : null;
  const [dateRange, setDateRange] = useState(() => {
    const now = dayjs();
    return [now.startOf('month'), now.endOf('month')];
  });

  const [quickDateFilter, setQuickDateFilter] = useState('thisMonth');
  const [editingDeliveryDate, setEditingDeliveryDate] = useState(null);
const [editingPartDate, setEditingPartDate] = useState(null);
  // Statistics
  const [statistics, setStatistics] = useState({
    totalPending: 0,
    totalAmount: 0,
    averageAmount: 0,
    deliveredCount: 0,
    acceptedCount: 0,
  });
   const [commentsModalVisible, setCommentsModalVisible] = useState(false);
    const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
    const [newComment, setNewComment] = useState('');
    const [addingComment, setAddingComment] = useState(false);

  const isAdmin = loginAgent?.role === "ADMIN";
const [editingSpecification, setEditingSpecification] = useState(null);
const [editingSpecValue, setEditingSpecValue] = useState('');
const [updatingSpecification, setUpdatingSpecification] = useState(false);
 

const handleUpdateSpecification = async (leadId, newSpecification) => {
    if (!leadId) return;
    
    const trimmedValue = newSpecification?.trim() || '';
    
    if (trimmedValue.length > 2000) {
        message.warning('Specification cannot exceed 2000 characters');
        return;
    }
    
    setUpdatingSpecification(true);
    try {
        // First, get the current lead data to preserve other vehicleInfo fields
        const currentLead = leads.find(lead => lead._id === leadId);
        const currentVehicleInfo = currentLead?.vehicleInfo || {};
        
        // Merge the specification with existing vehicleInfo
        const payload = {
            vehicleInfo: {
                ...currentVehicleInfo, // Preserve all existing fields
                specification: trimmedValue // Update only specification
            }
        };
        
        console.log('Sending payload with preserved data:', payload);
        
        const response = await API.UpdateLead(leadId, payload);
        
        if (response?.status) {
            message.success('Specification updated successfully!');
            fetchLeads(); // Refresh the leads list
        } else {
            message.error(response?.message || 'Failed to update specification');
        }
    } catch (error) {
        console.error('Error updating specification:', error);
        message.error('Failed to update specification');
    } finally {
        setUpdatingSpecification(false);
        setEditingSpecification(null);
        setEditingSpecValue('');
    }
};

  // Get user data on mount
  useEffect(() => {
    const UD = localStorage.getItem('userData');
    if (!UD) {
      navigate(ROUTES?.LOGIN);
      return;
    }
    const parsedUser = JSON.parse(UD);
    setLoginAgent(parsedUser);
    
    if (parsedUser?.role === "ADMIN") {
      fetchAgents();
    }
    fetchServiceAgents();
  }, [navigate]);

  const getRelocateStatusDate = (record) => {
  if (record.relocateStatusUpdatedAt) {
    return toPST(record.relocateStatusUpdatedAt);
  }
  return null;
};


// Handle opening the service agent selection modal
const handleServiceAgentEdit = (record) => {
    const currentServiceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    setSelectedLeadForServiceAgent(record);
    setSelectedServiceAgentForLead(currentServiceAgentId || null);
    setServiceAgentModalVisible(true);
};

// Handle saving the service agent
const handleServiceAgentSave = async () => {
    if (!selectedLeadForServiceAgent) return;
    
    setSavingServiceAgent(true);
    
    try {
        const payload = {
            orderServiceHandledBy: selectedServiceAgentForLead || null // Set to null if unassigned
        };
        
        const response = await API.UpdateLead(selectedLeadForServiceAgent._id, payload);
        
        if (response?.status || response?.success) {
            message.success(selectedServiceAgentForLead ? 'Service agent assigned successfully!' : 'Service agent unassigned successfully!');
            
            // Update local state
            setLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === selectedLeadForServiceAgent._id ? { 
                        ...lead, 
                        orderServiceHandledBy: selectedServiceAgentForLead
                    } : lead
                )
            );
            
            // Close modal
            setServiceAgentModalVisible(false);
            setSelectedLeadForServiceAgent(null);
            setSelectedServiceAgentForLead(null);
            
            // Refresh leads to get populated agent data
            fetchLeads(true);
            fetchServiceAgents(); // Refresh the agents map
        } else {
            message.error(response?.message || 'Failed to assign service agent');
        }
    } catch (error) {
        console.error('Error assigning service agent:', error);
        message.error('Failed to save service agent assignment');
    } finally {
        setSavingServiceAgent(false);
    }
};

const handleRelocateEditStart = (record) => {
  setEditingId(record._id);
  setEditingField('relocateStatus');
  setEditingRelocateValue(record.relocateStatus || 'No');
  setEditingRelocateDate(record.relocateStatusUpdatedAt ? dayjs(record.relocateStatusUpdatedAt) : dayjs());
};

const handleRelocateEditCancel = () => {
  setEditingId(null);
  setEditingField(null);
  setEditingRelocateValue('');
  setEditingRelocateDate(null);
};

const handleRelocateEditSave = async (id) => {
  if (!editingRelocateDate) {
    message.warning('Please select a date');
    return;
  }

  try {
    const payload = {
      relocateStatus: editingRelocateValue,
      relocateStatusUpdatedAt: editingRelocateDate.toISOString()
    };

    const response = await API.UpdateLead(id, payload);

    if (response.status) {
      message.success(`Relocate status updated to ${editingRelocateValue === 'Yes' ? 'Yes' : 'No'}!`);
      setEditingId(null);
      setEditingField(null);
      setEditingRelocateValue('');
      setEditingRelocateDate(null);
      await fetchLeads();
    } else {
      message.error('Failed to update relocate status');
    }
  } catch (error) {
    console.error('Error updating relocate status:', error);
    message.error('Error updating relocate status');
  }
};

  const handleAddComment = async () => {
    if (!newComment.trim()) {
        message.warning('Please enter a comment');
        return;
    }

    if (!selectedLeadForComment) return;

    setAddingComment(true);
    try {
        const existingComments = selectedLeadForComment.paymentPageComment || [];
        const payload = {
            paymentPageComment: [
                ...existingComments,
                {
                    comment: newComment.trim(),
                    changedAt: new Date().toISOString()
                }
            ]
        };

        const response = await API.UpdateLead(selectedLeadForComment._id, payload);

        if (response?.status) {
            message.success('Comment added successfully!');
            setNewComment('');
            setCommentsModalVisible(false);
            setSelectedLeadForComment(null);
            // Refresh the leads list
            fetchLeads();
        } else {
            message.error(response?.message || 'Failed to add comment');
        }
    } catch (error) {
        console.error('Error adding comment:', error);
        message.error('Failed to add comment');
    } finally {
        setAddingComment(false);
    }
};

const formatCommentDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
};


const getServiceAgentName = (record) => {
    const serviceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    if (!serviceAgentId) return null;
    
    // Check if already populated as object
    if (record.orderServiceHandledBy && typeof record.orderServiceHandledBy === 'object') {
        return `${record.orderServiceHandledBy.firstName || ''} ${record.orderServiceHandledBy.lastName || ''}`.trim() || 
               record.orderServiceHandledBy.userName || 'Service Agent';
    }
    
    // Check in our map
    const agentInfo = serviceAgentsMap[serviceAgentId];
    return agentInfo?.name || null;
};

const fetchServiceAgents = async () => {
    setLoadingServiceAgents(true);
    try {
        const response = await API.userGetAll();
        if (response?.success) {
            const agentsMap = {};
            // Get all users with SERVICE-AGENT or SUPPORT-AGENT role
            const serviceAgentsList = (response.data || []).filter(
                user => user.role === "SERVICE-AGENT" || user.role === "SUPPORT-AGENT"
            );
            serviceAgentsList.forEach(agent => {
                agentsMap[agent._id] = {
                    name: `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || agent.userName || agent.email,
                    email: agent.email,
                    phone: agent.directNumber,
                    role: agent.role
                };
            });
            setServiceAgentsMap(agentsMap);
        }
    } catch (error) {
        console.error("Failed to fetch service agents", error);
    } finally {
        setLoadingServiceAgents(false);
    }
};
  const fetchAgents = async () => {
    try {
      const response = await API.userGetAll();
      if (response?.success) {
        const salesAgents = (response.data || []).filter(user => user.role === "SALES-AGENT");
        setAgents(salesAgents);
      }
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  };

  // Get agent name function
  const getAgentName = (record) => {
    if (record.assignedAgent?.name) return record.assignedAgent.name;
    if (record.agentName) return record.agentName;
    if (record.handledBy?.firstName && record.handledBy?.lastName) {
      return `${record.handledBy.firstName} ${record.handledBy.lastName}`;
    }
    if (record.handledBy?.name) return record.handledBy.name;
    return 'Unassigned';
  };

  // Get unique agents for filter
  const getUniqueAgents = () => {
    const agentNames = leads
      .map(lead => getAgentName(lead))
      .filter((value, index, self) => value && self.indexOf(value) === index);
    return agentNames;
  };

  // Fetch yard details for all leads when leads change
  useEffect(() => {
    const fetchAllYardDetails = async () => {
      const yardIds = new Set();
      
      leads.forEach(lead => {
        const yards = lead.yard || [];
        const latestYard = yards.length > 0 ? yards[yards.length - 1] : null;
        if (latestYard?.yardId && !yardDetailsMap[latestYard.yardId]) {
          yardIds.add(latestYard.yardId);
        }
      });

      if (yardIds.size === 0) return;

      for (const yardId of yardIds) {
        try {
          const response = await API.GetYardById(yardId);
          if (response?.status || response?.success) {
            const yardData = response.data || response;
            setYardDetailsMap(prev => ({
              ...prev,
              [yardId]: yardData
            }));
          }
        } catch (error) {
          console.error('Error fetching yard details for', yardId, error);
        }
      }
    };

    if (leads.length > 0) {
      fetchAllYardDetails();
    }
  }, [leads]);

  // Get unique values for filters
  const getUniqueValues = (field) => {
    const values = leads
      .map(lead => {
        if (field === 'part') {
          return lead.vehicleInfo?.part;
        }
        return lead[field];
      })
      .filter((value, index, self) => value && self.indexOf(value) === index);
    return values;
  };

  // Calculate statistics
  const calculateStatistics = (data) => {
    const totalPending = data.length;
    const totalAmount = data.reduce((sum, lead) => sum + (lead.totalAmount || 0), 0);
    const averageAmount = totalPending > 0 ? totalAmount / totalPending : 0;
    const deliveredCount = data.filter(lead => lead.orderProcessComplete?.deliveryStatus === 'Delivered').length;
    const acceptedCount = data.filter(lead => lead.orderProcessComplete?.partStatus === 'Customer Accepted').length;
    
    setStatistics({
      totalPending,
      totalAmount,
      averageAmount,
      deliveredCount,
      acceptedCount,
    });
  };

  // Get date range based on quick filter
  const getQuickDateRange = (filterType) => {
    const now = dayjs();
    let startDate = now;
    let endDate = now;

    switch (filterType) {
      case 'today':
        startDate = now.startOf('day');
        endDate = now.endOf('day');
        break;
      case 'yesterday':
        startDate = now.subtract(1, 'day').startOf('day');
        endDate = now.subtract(1, 'day').endOf('day');
        break;
      case 'thisWeek':
        startDate = now.startOf('week');
        endDate = now.endOf('week');
        break;
      case 'thisMonth':
        startDate = now.startOf('month');
        endDate = now.endOf('month');
        break;
      case 'lastMonth':
        startDate = now.subtract(1, 'month').startOf('month');
        endDate = now.subtract(1, 'month').endOf('month');
        break;
      case 'thisQuarter':
        startDate = now.startOf('quarter');
        endDate = now.endOf('quarter');
        break;
      case 'thisYear':
        startDate = now.startOf('year');
        endDate = now.endOf('year');
        break;
      default:
        return null;
    }

    return [startDate, endDate];
  };

  // Set default date range to current month on component mount
  useEffect(() => {
    const defaultDateRange = getQuickDateRange('thisMonth');
    setDateRange(defaultDateRange);
  }, []);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, effectiveSearchFields, dateRange, filteredInfo, sortedInfo.field, sortedInfo.order, selectedAgentId]);

  // Handle quick date filter change
  const handleQuickDateFilter = (value) => {
    setQuickDateFilter(value);
    const newDateRange = getQuickDateRange(value);
    setDateRange(newDateRange);
    setCurrentPage(1);
  };

const fetchLeads = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    
    try {
      const isSearching = Boolean(searchQuery);
      const params = {
        page: currentPage,
        limit: pageSize,
        sortBy: sortedInfo.field || 'updatedAt',
        order: sortedInfo.order === 'ascend' ? 'asc' : 'desc',
        status: 'Sales Made',
        shipmentDeliveryStatus: 'Delivered'
      };

      if (isSearching) {
        params.search = searchQuery;
        params.searchFields = searchFields;
      } else {
        params.dateField = 'shipmentDeliveredDate';

        // Add null check for dateRange
        if (dateRange && dateRange[0] && dateRange[1]) {
          params.startDate = dateRange[0].startOf('day').toISOString();
          params.endDate = dateRange[1].endOf('day').toISOString();
        }
      }

      if (filteredInfo.part) {
        params.part = filteredInfo.part.join(',');
      }

      if (filteredInfo.invoiceStatus) {
        params.invoiceStatus = filteredInfo.invoiceStatus.join(',');
      }

      if (filteredInfo.purchaseOrderStatus) {
        params.purchaseOrderStatus = filteredInfo.purchaseOrderStatus.join(',');
      }

      if (isAdmin && selectedAgentId) {
        params.agentId = selectedAgentId;
      }

      // The server sends only the fields this page uses
      // (LeadController LEAD_VIEW_FIELDS['order-complete']).
      params.view = 'order-complete';
      const response = await API.leadGetAll(params);
      
      if (response.status && response.data) {
        setLeads(response.data);
        calculateStatistics(response.data);
        
        const possibleTotal = response.pagination?.totalRecords || 
                              response.total || 
                              response.totalRecords ||
                              response.data.length;
        
        setTotalRecords(possibleTotal);
      }
    } catch (error) {
      console.error('Error fetching leads:', error);
      message.error('Failed to fetch leads');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };


  // Handle refresh
  const handleRefresh = () => {
    fetchLeads(true);
  };

  // Handle search
  const handleSearch = (value) => {
    setSearchText(value);
  };

  // Handle date range change
  const handleDateRangeChange = (dates) => {
    if (!dates || dates.length === 0) {
      // When cleared, set to default date range (this month)
      const defaultRange = getQuickDateRange('thisMonth');
      setDateRange(defaultRange);
      setQuickDateFilter('thisMonth');
    } else {
      setDateRange(dates);
      setQuickDateFilter('custom');
    }
  };
  // Handle clear filters
 const handleClearFilters = () => {
    setSearchText('');
    const defaultDateRange = getQuickDateRange('thisMonth');
    setDateRange(defaultDateRange);
    setQuickDateFilter('thisMonth');
    setFilteredInfo({ part: null, invoiceStatus: null, purchaseOrderStatus: null, agent: null });
    setSelectedAgentId(null);
    setSortedInfo({ field: 'updatedAt', order: 'descend' });
    setCurrentPage(1);
    message.info({
      content: "All filters cleared",
      icon: <ClearOutlined />
    });
  };
  // Handle view button click
  const handleView = (record) => {
    setSelectedLeadId(record._id);
    navigate(`/lead-details/${record._id}`);
  };

  // Handle table change
  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  // Handle pagination change
  const handlePaginationChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };
const getStatusDate = (record, fieldName, statusValue) => {
  if (!record.orderProcessCompleteHistory || record.orderProcessCompleteHistory.length === 0) {
    return null;
  }
  
  const matchingEntries = record.orderProcessCompleteHistory.filter(
    entry => entry.field === fieldName && entry.newValue === statusValue
  );
  
  if (matchingEntries.length === 0) return null;
  
  // Return the oldest entry (first time this status was set)
  const sortedEntries = [...matchingEntries].sort((a, b) => 
    new Date(a.changedAt) - new Date(b.changedAt)
  );
  
  return sortedEntries[0]?.changedAt;
};
const handleEditStart = (record, field) => {
  setEditingId(record._id);
  setEditingField(field);

  if (field === "deliveryStatus") {
    setEditingValue(record.orderProcessComplete?.deliveryStatus || "Not Delivered");
    // Get existing date from history or use current date
    const existingDate = getStatusDate(record, 'orderProcessComplete.deliveryStatus', 'Delivered');
    setEditingDeliveryDate(existingDate ? dayjs(existingDate) : dayjs());
  } else if (field === "partStatus") {
    setEditingValue(record.orderProcessComplete?.partStatus || "Customer Accepted");
    // Get existing date from history or use current date
    const existingDate = getStatusDate(record, 'orderProcessComplete.partStatus', record.orderProcessComplete?.partStatus);
    setEditingPartDate(existingDate ? dayjs(existingDate) : dayjs());
  } else {
    setEditingValue(record[field]);
  }
};
  // Handle edit cancel
  const handleEditCancel = () => {
    setEditingId(null);
    setEditingField(null);
    setEditingValue('');
  };
  
const handleEditSave = async (id) => {
  try {
    let updatedData = {};
    const currentLead = leads.find(l => l._id === id);
    const changeDate = editingField === "deliveryStatus" ? editingDeliveryDate : editingPartDate;
    
    if (!changeDate) {
      message.warning('Please select a date');
      return;
    }
    
    const changeDateISO = changeDate.toISOString();
    
    if (editingField === "deliveryStatus") {
      // Get old value
      const oldValue = currentLead?.orderProcessComplete?.deliveryStatus || "Not Delivered";
      const newValue = editingValue;
      
      updatedData = {
        orderProcessComplete: {
          ...currentLead?.orderProcessComplete,
          deliveryStatus: editingValue
        },
        // Also update ShipmentTracking deliveryStatus to match
        ShipmentTracking: {
          ...currentLead?.ShipmentTracking,
          deliveryStatus: editingValue
        }
      };
      
      // Add to history
      if (!updatedData.orderProcessCompleteHistory) {
        updatedData.orderProcessCompleteHistory = [...(currentLead?.orderProcessCompleteHistory || [])];
      } else {
        updatedData.orderProcessCompleteHistory = [...(currentLead?.orderProcessCompleteHistory || [])];
      }
      
      updatedData.orderProcessCompleteHistory.push({
        field: 'orderProcessComplete.deliveryStatus',
        oldValue: oldValue,
        newValue: newValue,
        changedAt: changeDateISO
      });
    }

    if (editingField === "partStatus") {
      const oldValue = currentLead?.orderProcessComplete?.partStatus || "Customer Accepted";
      const newValue = editingValue;
      
      updatedData = {
        orderProcessComplete: {
          ...currentLead?.orderProcessComplete,
          partStatus: editingValue
        }
      };
      
      // Sync ShipmentTracking partStatus based on condition
      if (editingValue === "Customer Canceled") {
        updatedData.ShipmentTracking = {
          ...currentLead?.ShipmentTracking,
          partStatus: "Customer Canceled Order",
          priority: "Low"
        };
      } else if (editingValue === "Customer Accepted") {
        if (currentLead?.ShipmentTracking?.partStatus === "Customer Canceled Order") {
          updatedData.ShipmentTracking = {
            ...currentLead?.ShipmentTracking,
            partStatus: "Available"
          };
        }
      }
      
      // Add to history
      if (!updatedData.orderProcessCompleteHistory) {
        updatedData.orderProcessCompleteHistory = [...(currentLead?.orderProcessCompleteHistory || [])];
      } else {
        updatedData.orderProcessCompleteHistory = [...(currentLead?.orderProcessCompleteHistory || [])];
      }
      
      updatedData.orderProcessCompleteHistory.push({
        field: 'orderProcessComplete.partStatus',
        oldValue: oldValue,
        newValue: newValue,
        changedAt: changeDateISO
      });
    }

    const response = await API.UpdateLead(id, updatedData);

    if (response.status) {
      message.success("Order process updated successfully with date!");
      setEditingId(null);
      setEditingField(null);
      setEditingValue("");
      setEditingDeliveryDate(null);
      setEditingPartDate(null);
      await fetchLeads();
    } else {
      message.error("Failed to update");
    }
  } catch (error) {
    console.error(error);
    message.error("Error updating");
  }
};

  useEffect(() => {
    fetchLeads();
  }, [
    currentPage, 
    pageSize, 
    sortedInfo.field, 
    sortedInfo.order, 
    filteredInfo.part,
    filteredInfo.invoiceStatus,
    filteredInfo.purchaseOrderStatus,
    searchQuery,
    effectiveSearchFields,
    dateRange,
    selectedAgentId,
    selectedServiceAgentId
  ]);

  const isSearching = searchText?.trim().length > 0;

const handleViewYardDetails = (record) => {
  navigate(`/lead-details/${record._id}`, {
    state: {
      sourceTab: 'order-process',
      activeTab: 'yard'
    }
  });
};

const handleReAssignYard = (record) => {
  setSelectedLeadForYard(record);
  setYardModalVisible(true);
};

const handleYardModalClose = () => {
  setYardModalVisible(false);
  setSelectedLeadForYard(null);
};

const handleYardModalSuccess = () => {
  setYardModalVisible(false);
  setSelectedLeadForYard(null);
  message.success('Yard reassigned successfully');
  fetchLeads(true);
};
  // Agent column definition
  const agentColumn = isAdmin ? [{
    title: 'Sales-Agent',
    key: 'agent',
    width: 140,
    sorter: (a, b) => getAgentName(a).localeCompare(getAgentName(b)),
    filters: getUniqueAgents().map(value => ({ text: value, value })),
    filteredValue: filteredInfo.agent || null,
    render: (_, record) => {
      const agentName = getAgentName(record);
      const isUnassigned = agentName === 'Unassigned';
      return (
        <Tooltip title={agentName}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar
              size={32}
              icon={<UserOutlined />}
              style={{
                backgroundColor: isUnassigned ? '#d9d9d9' : '#722ed1',
                flexShrink: 0,
              }}
            >
              {!isUnassigned && agentName?.[0]?.toUpperCase()}
            </Avatar>
            <Text
              ellipsis={{ tooltip: true }}
              style={{
                fontSize: 13,
                color: isUnassigned ? '#8c8c8c' : '#1f2937',
                fontStyle: isUnassigned ? 'italic' : 'normal',
              }}
            >
              {agentName}
            </Text>
          </div>
        </Tooltip>
      );
    },
  }] : [];

  const columns = [
      {
        title: "Order Number",
        width: 108,
        key: "orderNumber",
        render: (_, record) => {
          const hasOrderNumber = record.orderNumber;
          
          return (
            <div>
              {/* Order Number Section */}
              <div style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                background: hasOrderNumber ? '#f0f0ff' : '#fff1f0',
                padding: '4px 8px',
                borderRadius: 8,
                width: 'fit-content'
              }}>
                {hasOrderNumber ? (
                  <FileTextOutlined style={{ color: '#722ed1', fontSize: 12 }} />
                ) : (
                  <ClockCircleOutlined style={{ color: '#ff4d4f', fontSize: 12 }} />
                )}
                <Text style={{ 
                  color: hasOrderNumber ? '#722ed1' : '#ff4d4f',
                  fontSize: 12,
                  fontWeight: 600,
                  fontFamily: 'monospace',
                  fontStyle: hasOrderNumber ? 'normal' : 'italic'
                }}>
                  {hasOrderNumber ? `#${record.orderNumber.slice(-8)}` : 'Waiting..'}
                </Text>
                {hasOrderNumber && (
                  <Tooltip title="Copy Order Number">
                    <Button
                      type="text"
                      size="small"
                      icon={<CopyOutlined style={{ fontSize: 10 }} />}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard.writeText(record.orderNumber);
                        message.success('Order number copied!');
                      }}
                      style={{
                        padding: 0,
                        height: 18,
                        width: 18,
                        minWidth: 18,
                        color: '#722ed1',
                      }}
                    />
                  </Tooltip>
                )}
              </div>
              
              {/* Date Section - Shows Order Date or Created Date */}
              {(record.orderDate || record.createdAt) && (
                <div style={{ 
                  marginTop: 6,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  paddingLeft: 4
                }}>
                  <CalendarOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                  <Tooltip 
                    title={dayjs(record.orderDate || record.createdAt).format('MMM DD, YYYY hh:mm A')}
                  >
                    <Text type="secondary" style={{ fontSize: 10 }}>
                      {record.orderDate 
                        ? dayjs(record.orderDate).format('MM/DD/YY hh:mm A')
                        : ` ${dayjs(record.createdAt).format('MM/DD/YY hh:mm A')}`
                      }
                    </Text>
                  </Tooltip>
                </div>
              )}
            </div>
          );
        }
      },
    ...agentColumn,
    {
    title:  'Order Service-Agent',
    key: 'serviceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getServiceAgentName(a) || '';
        const nameB = getServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const serviceAgentName = getServiceAgentName(record);
        const isAssigned = !!serviceAgentName;
        
        return (
            <div 
                style={{ cursor: 'pointer' }}
                onClick={() => handleServiceAgentEdit(record)}
            >
                <Tooltip title={isAssigned ? `Click to change service agent` : 'Click to assign service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar
                            size={32}
                            icon={<TeamOutlined />}
                            style={{
                                backgroundColor: isAssigned ? '#52c41a' : '#f0f0f0',
                                flexShrink: 0,
                            }}
                        >
                            {isAssigned && serviceAgentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text
                                        ellipsis={{ tooltip: true }}
                                        style={{
                                            fontSize: 13,
                                            color: '#1f2937',
                                            display: 'block',
                                            fontWeight: 500
                                        }}
                                    >
                                        {serviceAgentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>
                                        Click to edit
                                    </Text>
                                </>
                            ) : (
                                <Text
                                    style={{
                                        fontSize: 13,
                                        color: '#1890ff',
                                        fontStyle: 'italic'
                                    }}
                                >
                                    + Assign Agent
                                </Text>
                            )}
                        </div>
                        <EditOutlined 
                            style={{ 
                                fontSize: 12, 
                                color: '#1890ff',
                                opacity: 0.6
                            }} 
                        />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
    {
      title: 'Customer',
      key: 'customer',
      fixed: 'left',
      width: 270,
      sorter: true,
      sortOrder: sortedInfo.field === 'customer' && sortedInfo.order,
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, minWidth: 0 }}>
          <Avatar 
            size={38}
            icon={<UserOutlined />} 
            style={{ 
              background: `linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)`,
              boxShadow: '0 4px 12px rgba(24,144,255,0.2)',
              flexShrink: 0
            }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <Text
              strong
              ellipsis={{ tooltip: record.personalInfo?.fullName || 'N/A' }}
              style={{ fontSize: 14, display: 'block', marginBottom: 4 }}
            >
              {record.personalInfo?.fullName || 'N/A'}
            </Text>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
                <MailOutlined style={{ color: '#1890ff', fontSize: 11 }} />
                <Text
                  type="secondary"
                  ellipsis={{ tooltip: record.personalInfo?.email || 'N/A' }}
                  style={{ fontSize: 12, display: 'block', minWidth: 0 }}
                >
                  {record.personalInfo?.email || 'N/A'}
                </Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
                <PhoneOutlined style={{ color: '#52c41a', fontSize: 11 }} />
                <Text
                  type="secondary"
                  ellipsis={{ tooltip: record.personalInfo?.phoneNumber || 'N/A' }}
                  style={{ fontSize: 12, display: 'block', minWidth: 0 }}
                >
                  {record.personalInfo?.phoneNumber || 'N/A'}
                </Text>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: 'Vehicle & Part',
      key: 'vehicle',
      width: 230,
      render: (_, record) => (
        <Card size="small" style={{ borderRadius: 10, background: '#fafafa', border: 'none' }} bodyStyle={{ padding: '8px 10px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
              <CarOutlined style={{ color: '#faad14', fontSize: 12, marginTop: 2, flexShrink: 0 }} />
              <Text strong style={{ fontSize: 13, display: 'block', lineHeight: 1.25, wordBreak: 'break-word' }}>
                {record.vehicleInfo?.year || ''} {record.vehicleInfo?.make || ''}
              </Text>
            </div>
            <Text type="secondary" style={{ fontSize: 12, marginLeft: 16, display: 'block', lineHeight: 1.25, wordBreak: 'break-word' }}>
              {record.vehicleInfo?.model || 'N/A'}
            </Text>
            {record.vehicleInfo?.variant && (
              <Tag style={{ marginLeft: 16, marginTop: 2, fontSize: 10, whiteSpace: 'normal', lineHeight: 1.2 }}>
                {record.vehicleInfo.variant}
              </Tag>
            )}
            <div style={{ marginTop: 6, borderTop: '1px dashed #e8e8e8', paddingTop: 6 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
                <TagOutlined style={{ color: '#1890ff', fontSize: 11 }} />
                <Tag color="cyan" style={{ fontSize: 11, whiteSpace: 'normal', lineHeight: 1.2, marginRight: 0 }}>
                  {record.vehicleInfo?.part || 'N/A'}
                </Tag>
              </div>
            </div>
          </div>
        </Card>
      ),
    },
          {
    title: 'Specification',
    key: 'specification',
    width: 250,
    render: (_, record) => {
        const specification = record.vehicleInfo?.specification || '';
        const isEditing = editingSpecification === record._id;
        
        if (isEditing) {
            return (
                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                    <Input.TextArea
                        autoSize={{ minRows: 2, maxRows: 4 }}
                        value={editingSpecValue}
                        onChange={(e) => setEditingSpecValue(e.target.value)}
                        placeholder="Enter specification details..."
                        style={{ flex: 1, fontSize: '12px' }}
                        autoFocus
                        maxLength={2000}
                        showCount
                    />
                    <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                        <Button
                            size="small"
                            type="primary"
                            icon={<CheckOutlined />}
                            loading={updatingSpecification}
                            onClick={() => handleUpdateSpecification(record._id, editingSpecValue)}
                            style={{ minWidth: '32px' }}
                        />
                        <Button
                            size="small"
                            icon={<CloseOutlined />}
                            onClick={() => {
                                setEditingSpecification(null);
                                setEditingSpecValue('');
                            }}
                        />
                    </div>
                </div>
            );
        }
        
        return (
            <div 
                style={{ 
                    cursor: 'pointer',
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.3s',
                    backgroundColor: specification ? 'transparent' : '#fafafa',
                    border: '1px solid transparent',
                    minHeight: '60px'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                    e.currentTarget.style.borderColor = '#d9d9d9';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = specification ? 'transparent' : '#fafafa';
                    e.currentTarget.style.borderColor = 'transparent';
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    setEditingSpecification(record._id);
                    setEditingSpecValue(specification);
                }}
            >
                {specification ? (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <FileTextOutlined style={{ color: '#52c41a', fontSize: '12px' }} />
                            <Text strong style={{ fontSize: '12px', color: '#52c41a' }}>Specification:</Text>
                        </div>
                        <Text style={{ 
                            fontSize: '12px', 
                            whiteSpace: 'pre-wrap', 
                            wordBreak: 'break-word',
                            display: 'block',
                            lineHeight: '1.5'
                        }}>
                            {specification.length > 100 
                                ? `${specification.substring(0, 100)}...` 
                                : specification}
                        </Text>
                        <div style={{ marginTop: '4px' }}>
                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                <EditOutlined style={{ marginRight: '4px' }} />
                                Click to edit
                            </Text>
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '12px' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <FileTextOutlined style={{ marginRight: '4px', color: '#52c41a' }} />
                            <EditOutlined style={{ marginRight: '4px', fontSize: '10px' }} />
                            Click to add specification
                        </Text>
                    </div>
                )}
            </div>
        );
    },
}, 
{
    title: 'Yard',
    key: 'yard',
    width: 200, // Increased width to accommodate verification info
    render: (_, record) => {
        const latestYard = record.yard?.length > 0 
            ? record.yard[record.yard.length - 1] 
            : null;
        const yardDetails = latestYard?.yardId 
            ? yardDetailsMap[latestYard.yardId] 
            : null;

        if (!latestYard) {
            return (
                <div>
                    <Space>
                        <Text type="secondary">No yard assigned</Text>
                        <Tooltip title="View Yard Details">
                            <Button
                                type="text"
                                size="small"
                                shape="circle"
                                icon={<EyeOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewYardDetails(record);
                                }}
                            />
                        </Tooltip>
                    </Space>
                    <div style={{ marginTop: 8 }}>
                        <Button
                            type="link"
                            size="small"
                            icon={<ShopOutlined />}
                            onClick={() => handleReAssignYard(record)}
                            style={{ padding: 0 }}
                        >
                            Assign Yard
                        </Button>
                    </div>
                </div>
            );
        }

        const isVerified = latestYard.verifiedAmountStats === 'YES';
        const verifiedPrice = latestYard.verifiedAmountPrice || 0;
        const finalPrice = latestYard.finalPrice || latestYard.price || 0;
        const priceDifference = verifiedPrice - finalPrice;
        const hasDifference = priceDifference !== 0;

        return (
            <div>
                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                    <Space>
                        <ShopOutlined style={{ color: '#722ed1' }} />
                        <Text strong>
                            {yardDetails?.yardName || 'Loading...'}
                        </Text>
                        <Tooltip title="View Yard Details">
                            <Button
                                type="text"
                                size="small"
                                shape="circle"
                                icon={<EyeOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewYardDetails(record);
                                }}
                            />
                        </Tooltip>
                    </Space>
                    
                    <div style={{ fontSize: 12 }}>
                        <div>
                            💰 Price: ${finalPrice.toFixed(2)}
                        </div>
                        {latestYard.yardConfirmDate && (
                            <div>
                                📅 {dayjs(latestYard.yardConfirmDate).format('MM/DD/YYYY')}
                            </div>
                        )}
                    </div>

                    {/* Verification Status Display */}
                    <div style={{ marginTop: '4px' }}>
                        {isVerified ? (
                            <div>
                                <Space size={4} wrap>
                                    <Tag color="success" size="small" style={{ fontSize: '11px', margin: 0 }}>
                                        <CheckCircleOutlined /> Verified
                                    </Tag>
                                    {hasDifference ? (
                                        <Tag 
                                            color={priceDifference > 0 ? 'orange' : 'red'} 
                                            style={{ fontSize: '11px', margin: 0 }}
                                        >
                                            {priceDifference > 0 ? '▲' : '▼'} ${Math.abs(priceDifference).toFixed(2)} diff
                                        </Tag>
                                    ) : (
                                        <Tag color="green" style={{ fontSize: '11px', margin: 0 }}>
                                            ✓ Matches
                                        </Tag>
                                    )}
                                    <Tooltip title={`Verified: $${verifiedPrice.toFixed(2)} | Final: $${finalPrice.toFixed(2)} | Difference: ${priceDifference > 0 ? '+' : ''}${priceDifference.toFixed(2)}`}>
                                        <InfoCircleOutlined style={{ color: '#1890ff', fontSize: '12px', cursor: 'pointer' }} />
                                    </Tooltip>
                                </Space>
                                <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                                    ✓ ${verifiedPrice.toFixed(2)}
                                </div>
                            </div>
                        ) : (
                            <Tag color="warning" size="small" style={{ fontSize: '11px' }}>
                                <ClockCircleOutlined /> Not Verified
                            </Tag>
                        )}
                    </div>

                    <Space direction="vertical" size={2} style={{ alignItems: 'flex-start' }}>
                        <Button
                            type="link"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => handleReAssignYard(record)}
                            style={{ padding: 0, fontSize: 12 }}
                        >
                            Re-assign Yard
                        </Button>
                        {record.yardReassignmentHistory?.length > 0 && (
                            <Tooltip title="View yard reassignment history">
                                <Button
                                    type="link"
                                    size="small"
                                    icon={<HistoryOutlined />}
                                    onClick={() => setYardHistoryLead(record)}
                                    style={{ padding: 0, fontSize: 12 }}
                                >
                                    History ({record.yardReassignmentHistory.length})
                                </Button>
                            </Tooltip>
                        )}
                    </Space>
                </Space>
            </div>
        );
    }
},

{
  title: 'Relocated',
  key: 'relocated',
  width: 180,
  align: 'center',
  render: (_, record) => {
    const relocateStatus = record.relocateStatus || 'No';
    const relocateDate = getRelocateStatusDate(record);
    const isEditing = editingId === record._id && editingField === 'relocateStatus';
    
    if (isEditing) {
      return (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <Select
            value={editingRelocateValue}
            onChange={(value) => setEditingRelocateValue(value)}
            style={{ width: '100%' }}
            size="small"
          >
            <Option value="Yes">
              <Space>
                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                <span>Yes - Relocated</span>
              </Space>
            </Option>
            <Option value="No">
              <Space>
                <CloseCircleOutlined style={{ color: '#f5222d' }} />
                <span>No - Not Relocated</span>
              </Space>
            </Option>
          </Select>
          <DatePicker
            value={editingRelocateDate}
            onChange={(date) => setEditingRelocateDate(date)}
            size="small"
            placeholder="Select date"
            style={{ width: '100%' }}
            format="MM/DD/YYYY"
          />
          <Space size={4}>
            <Button 
              type="primary" 
              size="small" 
              icon={<CheckOutlined />} 
              onClick={() => handleRelocateEditSave(record._id)}
              style={{ flex: 1, borderRadius: 6 }}
            />
            <Button 
              size="small" 
              icon={<CloseOutlined />} 
              onClick={handleRelocateEditCancel}
              style={{ borderRadius: 6 }}
            />
          </Space>
        </Space>
      );
    }
    
    return (
      <div>
        <Space size={4}>
          <Tag 
            color={relocateStatus === 'Yes' ? 'purple' : 'default'}
            icon={relocateStatus === 'Yes' ? <CheckCircleOutlined /> : <ReloadOutlined />}
            style={{ 
              padding: '4px 12px', 
              borderRadius: 16, 
              fontWeight: 500, 
              cursor: 'pointer',
              margin: 0
            }}
            onClick={() => handleRelocateEditStart(record)}
          >
            {relocateStatus === 'Yes' ? '✓ Relocated' : '✗ Not Relocated'}
          </Tag>
          <Tooltip title="Edit Relocate Status with Date">
            <Button 
              type="text" 
              icon={<EditOutlined />} 
              size="small"
              onClick={() => handleRelocateEditStart(record)}
              style={{ color: '#1890ff' }}
            />
          </Tooltip>
        </Space>
        {relocateDate && (
          <div style={{ marginTop: 6 }}>
            <Tooltip title={`Last updated: ${relocateDate.format('MMMM DD, YYYY hh:mm:ss A')} PST`}>
              <Space size={4}>
                <ClockCircleOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                <Text type="secondary" style={{ fontSize: 10 }}>
                  Since: {relocateDate.format('MM/DD/YY · hh:mm A')}
                </Text>
              </Space>
            </Tooltip>
          </div>
        )}
      </div>
    );
  },
},
{
  title: 'Part Status',
  key: 'partStatus',
  width: 160,
  align: 'center',
  render: (_, record) => {
    const status = record.orderProcessComplete?.partStatus || "Customer Accepted";
    
    // Get latest part status change date from orderProcessCompleteHistory
    const getPartUpdateDatePST = () => {
      if (record.orderProcessCompleteHistory && record.orderProcessCompleteHistory.length > 0) {
        const latestPartUpdate = [...record.orderProcessCompleteHistory]
          .filter(history => history.field === 'orderProcessComplete.partStatus')
          .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0];
        
        if (latestPartUpdate) {
          return toPST(latestPartUpdate.changedAt);
        }
      }
      return null;
    };
    
    const partUpdateDatePST = getPartUpdateDatePST();

    return (
      <div>
        <Tag 
          color={status === "Customer Accepted" ? "success" : "error"}
          style={{ padding: '4px 12px', borderRadius: 16, fontWeight: 500 }}
        >
          {status === "Customer Accepted" ? "✓ Accepted" : "❌ Canceled"}
        </Tag>
    
      </div>
    );
  }
},
  {
    title: 'Date Info',
    key: 'dateInfo',
    width: 180,
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    render: (_, record) => (
        <Tooltip
            title={
                <>
                    <div><strong>Created:</strong> {record.createdAt ? dayjs(record.createdAt).format('MM/DD/YYYY hh:mm A') : 'N/A'}</div>
                    <div><strong>Updated:</strong> {record.updatedAt ? dayjs(record.updatedAt).format('MM/DD/YYYY hh:mm A') : 'N/A'}</div>
                </>
            }
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>

                {/* Created */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                        width: 28, height: 28, borderRadius: 8,
                        background: '#F1EFE8',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    }}>
                        <ClockCircleOutlined style={{ fontSize: 13, color: '#888780' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2 }}>
                            {record.createdAt ? dayjs(record.createdAt).format('MM/DD/YY · hh:mm A') : 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                            Created · {record.createdAt ? dayjs(record.createdAt).fromNow() : '—'}
                        </Text>
                    </div>
                </div>

                {/* Updated */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                        width: 28, height: 28, borderRadius: 8,
                        background: '#E6F1FB',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    }}>
                        <SyncOutlined style={{ fontSize: 13, color: '#185FA5' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2, color: '#185FA5' }}>
                            {record.updatedAt ? dayjs(record.updatedAt).format('MM/DD/YY · hh:mm A') : 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                            Updated · {record.updatedAt ? dayjs(record.updatedAt).fromNow() : '—'}
                        </Text>
                    </div>
                </div>

            </div>
        </Tooltip>
    ),
},
{
    title: 'Comment',
    key: 'paymentPageComment',
    width: 280,
    render: (_, record) => {
        const comments = record.paymentPageComment || [];
        const latestComment = comments.length > 0 ? comments[comments.length - 1] : null;
        
        return (
            <div>
             

                {/* Display Latest Comment */}
                {latestComment ? (
                    <div 
                        style={{
                            background: '#fafafa',
                            padding: '8px 10px',
                            borderRadius: '8px',
                            border: '1px solid #f0f0f0',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            wordBreak: 'break-word',      // Add this
                            wordWrap: 'break-word',       // Add this
                            overflowWrap: 'break-word',   // Add this
                            whiteSpace: 'normal'          // Add this
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeadForComment(record);
                            setCommentsModalVisible(true);
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                {formatCommentDate(latestComment.changedAt)}
                            </Text>
                            {comments.length > 1 && (
                                <Tag 
                                    color="blue" 
                                    style={{ 
                                        fontSize: '10px', 
                                        padding: '0 4px', 
                                        margin: 0,
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedLeadForComment(record);
                                        setCommentsModalVisible(true);
                                    }}
                                >
                                    +{comments.length - 1} more
                                </Tag>
                            )}
                        </div>
                        <Text style={{ 
                            fontSize: '12px', 
                            display: 'block', 
                            wordBreak: 'break-word',    // Add this
                            whiteSpace: 'pre-wrap'       // Add this for preserving whitespace and wrapping
                        }}>
                            {latestComment.comment.length > 80 
                                ? `${latestComment.comment.substring(0, 80)}...` 
                                : latestComment.comment}
                        </Text>
                    </div>
                ) : (
                    <div 
                        style={{ 
                            textAlign: 'center', 
                            padding: '12px',
                            background: '#fafafa',
                            borderRadius: '8px',
                            border: '1px solid #f0f0f0',
                            cursor: 'pointer'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeadForComment(record);
                            setCommentsModalVisible(true);
                        }}
                    >
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <CommentOutlined style={{ marginRight: '4px', fontSize: '14px' }} />
                            No comments yet
                        </Text>
                    </div>
                )}
                   <Button
                    type="primary"
                    size="small"
                    icon={<CommentOutlined />}
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedLeadForComment(record);
                        setNewComment('');
                        setCommentsModalVisible(true);
                    }}
                    style={{ 
                        marginBottom: '12px',
                        width: '100%',
                        fontSize: '12px'
                    }}
                >
                    Add Comment
                </Button>
            </div>
        );
    },
},

    {
      title: '',
      key: 'actions',
      width: 52,
      fixed: 'right',
      align: 'center',
      render: (_, record) => (
        <Tooltip title="View Lead Details">
          <Button 
            type="primary"
            shape="circle"
            icon={<EyeOutlined />} 
            onClick={() => handleView(record)}
            style={{ 
              background: `linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)`,
              border: 'none',
              boxShadow: '0 2px 8px rgba(24,144,255,0.3)',
              width: 32,
              height: 32
            }}
          />
        </Tooltip>
      ),
    },
  ];

  const visibleColumns = columns.map((column) => {
    if (column.key !== 'dateInfo') {
      return column;
    }

    return {
      ...column,
      sorter: (a, b) => new Date(getShipmentDeliveredDate(a) || 0) - new Date(getShipmentDeliveredDate(b) || 0),
      render: (_, record) => {
        const deliveryDate = getShipmentDeliveredDate(record);
        const deliveryDatePST = toPST(deliveryDate);

        return (
          <Tooltip
            title={
              deliveryDatePST
                ? `Delivery Date: ${deliveryDatePST.format('MMM-DD-YYYY hh:mm A')} PST`
                : 'Delivery Date: N/A'
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  background: '#EAF7EE',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <CheckCircleOutlined style={{ fontSize: 13, color: '#237804' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2, color: '#237804' }}>
                    {deliveryDatePST ? deliveryDatePST.format('MM/DD/YY hh:mm A') : 'N/A'}
                  </Text>
                  <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                    {deliveryDatePST ? `Delivery Date | ${deliveryDatePST.fromNow()}` : 'Delivery Date'}
                  </Text>
                </div>
              </div>
            </div>
          </Tooltip>
        );
      },
    };
  });

  return (
    <div style={{ 
      padding: 24, 
      minHeight: "100vh", 
      background: `linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)`
    }}>
      {/* Modern Header with Stats */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Card 
          style={{ 
            marginBottom: 24, 
            borderRadius: 24,
            border: 'none'
          }}
          bodyStyle={{ padding: '32px' }}
        >
          <Row gutter={[24, 24]} align="middle">
            <Col xs={24} md={12}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <Avatar 
                  size={72} 
                  style={{ 
                    background: 'rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                    color:"black"
                  }}
                  icon={<CheckCircleOutlined style={{ fontSize: 36 }} />}
                />
                <div>
                  <Title level={2} style={{ margin: 0, fontWeight: 700 }}>
                    Order Process Complete
                  </Title>
                  <Text style={{  fontSize: 14 }}>
                    Manage and track completed orders
                  </Text>
                </div>
              </div>
            </Col>
        
          </Row>
        </Card>
      </motion.div>

      {/* Filter Section */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Card 
          bordered={false}
          style={{ 
            borderRadius: 20,
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            marginBottom: 24,
            border: '1px solid #f0f0f0'
          }}
          bodyStyle={{ padding: '20px 24px' }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} md={8}>
              <Space.Compact block>
                <SearchFieldsSelect value={searchFields} onChange={setSearchFields} />
                <Input
                  placeholder={getSearchFieldsPlaceholder(searchFields)}
                  prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  allowClear
                  size="large"
                />
              </Space.Compact>
            </Col>
            {isAdmin && (
              <Col xs={24} md={4}>
                <Select
                  placeholder="Filter by Agent"
                  value={selectedAgentId}
                  onChange={setSelectedAgentId}
                  style={{ width: '100%', borderRadius: 12 }}
                  size="large"
                  allowClear
                  suffixIcon={<TeamOutlined />}
                  showSearch
                  optionFilterProp="children"
                >
                  {agents.map(agent => (
                    <Option key={agent._id} value={agent._id}>
                      <Space>
                        <Avatar size="small" icon={<UserOutlined />} />
                        <span>{agent.firstName} {agent.lastName}</span>
                      </Space>
                    </Option>
                  ))}
                </Select>
              </Col>
            )}
            <Col xs={24} md={4}>
              <Select
                placeholder="Quick Date"
                style={{ width: '100%', borderRadius: 12 }}
                onChange={handleQuickDateFilter}
                value={quickDateFilter}
                size="large"
              >
                <Option value="today">Today</Option>
                <Option value="yesterday">Yesterday</Option>
                <Option value="thisWeek">This Week</Option>
                <Option value="thisMonth">This Month</Option>
                <Option value="lastMonth">Last Month</Option>
                <Option value="thisQuarter">This Quarter</Option>
                <Option value="thisYear">This Year</Option>
                <Option value="custom">Custom Range</Option>
              </Select>
            </Col>
            <Col xs={24} md={isAdmin ? 7 : 8}>
              <RangePicker
                style={{ width: '100%', borderRadius: 12 }}
                onChange={handleDateRangeChange}
                value={dateRange}
                size="large"
                format="MM/DD/YYYY"
                placeholder={['Start Date', 'End Date']}
                allowClear={false}
              />
            </Col>
            <Col xs={24} md={isAdmin ? 4 : 6}>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Tooltip title="Refresh">
                  <Button 
                    icon={<ReloadOutlined />} 
                    onClick={handleRefresh}
                    loading={refreshing}
                    size="large"
                    style={{ borderRadius: 12 }}
                  />
                </Tooltip>
                <Tooltip title="Clear Filters">
                  <Button 
                    icon={<ClearOutlined />} 
                    onClick={handleClearFilters}
                    size="large"
                    style={{ borderRadius: 12 }}
                  />
                </Tooltip>
              </Space>
            </Col>
          </Row>

          {dateRange && dateRange[0] && dateRange[1] && (
    <div style={{ 
      marginTop: 16,
      backgroundColor: '#f0f5ff', 
      padding: '8px 12px', 
      borderRadius: 12,
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }}>
      <CalendarOutlined style={{ color: '#1890ff' }} />
      <Text type="secondary">
        Showing completed orders from: <Text strong>{dateRange[0].format('MM/DD/YYYY')}</Text> to <Text strong>{dateRange[1].format('MM/DD/YYYY')}</Text>
      </Text>
      <Badge 
        count={totalRecords} 
        showZero 
        color="#52c41a" 
        style={{ marginLeft: 'auto' }}
      />
    </div>
  )}
        </Card>
      </motion.div>

       <div style={{
    padding: '16px 20px',
    background: '#ffffff',
    borderTop: '1px solid #f0f0f0',
    borderBottom: '1px solid #f0f0f0',
    borderRadius: '12px 12px 0 0',
    marginTop: 8
  }}>
    <Row justify="space-between" align="middle">
      <Col>
        <Space size={16}>
          <Text strong style={{ fontSize: 16 }}>
            {isSearching ? (
              <>
                <SearchOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                Search Results
              </>
            ) : (
              <>
                <CalendarOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                {dateRange && dateRange[0] && dateRange[1] ? (
                  dateRange[0].isSame(dateRange[1], 'day') ? (
                    dateRange[0].format('MM/DD/YYYY')
                  ) : (
                    `${dateRange[0].format('MMM D')} → ${dateRange[1].format('MM/DD/YYYY')}`
                  )
                ) : "Selected Period"}
              </>
            )}
          </Text>
          <Badge
            count={leads.length}
            showZero
            style={{
              backgroundColor: '#52c41a',
              fontSize: 12,
              fontWeight: 'bold'
            }}
          />
          <Text type="secondary">
            of {totalRecords.toLocaleString()} total records
          </Text>
        </Space>
      </Col>
      <Col>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={totalRecords}
          showSizeChanger
          pageSizeOptions={["10", "20", "50", "100"]}
          onChange={handlePaginationChange}
          size="small"
          simple
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        />
      </Col>
    </Row>
  </div>

      {/* Main Table */}
      <Card 
        bordered={false}
        style={{ 
          borderRadius: '0 0 20px 20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          overflow: 'hidden',
          borderTop: 'none'
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Table
          columns={visibleColumns}
          dataSource={leads}
          rowKey="_id"
          loading={loading}
          pagination={false}
          onChange={handleTableChange}
          scroll={{ x: isAdmin ? 1720 : 1580, y: 'calc(100vh - 550px)' }}
          bordered={false}
          size="middle"
          rowClassName={() => 'table-row-hover'}
          style={{
            background: 'transparent'
          }}
        />

        {/* Bottom Pagination */}
        {leads.length > 0 && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 32,
            padding: '20px 24px',
            background: '#fafafa',
            borderRadius: 12,
            margin: 24
          }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalRecords}
              showSizeChanger
              pageSizeOptions={["10", "20", "50", "100"]}
              onChange={handlePaginationChange}
              showQuickJumper
              showTotal={(total, range) =>
                `Showing ${range[0]}-${range[1]} of ${total} completed orders`
              }
              size="default"
            />
          </div>
        )}
      </Card>

      {/* Yard Details Modal */}


      <style>{`
        .table-row-hover:hover {
          background: linear-gradient(90deg, #f0f7ff 0%, #ffffff 100%) !important;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #f0f0f0 !important;
        }
        
        .ant-table-thead > tr > th {
          background: #fafafa !important;
          font-weight: 600 !important;
          font-size: 13px !important;
          color: #1f2937 !important;
          border-bottom: 2px solid #f0f0f0 !important;
        }
      `}</style>
       <Modal
         
          open={commentsModalVisible}
          onCancel={() => {
              setCommentsModalVisible(false);
              setSelectedLeadForComment(null);
              setNewComment('');
          }}
          footer={[
              <Button key="cancel" onClick={() => {
                  setCommentsModalVisible(false);
                  setSelectedLeadForComment(null);
                  setNewComment('');
              }}>
                  Cancel
              </Button>,
              <Button 
                  key="submit" 
                  type="primary" 
                  onClick={handleAddComment}
                  loading={addingComment}
                  disabled={!newComment.trim()}
              >
                  Add Comment
              </Button>
          ]}
          width={500}
      >
          <div style={{ padding: '16px 0' }}>
            
      
              <div>
                  <Text strong>Comment:</Text>
                  <Input.TextArea
                      placeholder="Enter your comment here..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      rows={4}
                      maxLength={1000}
                      showCount
                      style={{ marginTop: '8px' }}
                      autoFocus
                  />
              </div>
      
              {/* Show existing comments if any */}
              {selectedLeadForComment?.paymentPageComment?.length > 0 && (
                  <div style={{ marginTop: '20px' }}>
                      <Divider />
                      <Text strong>Previous Comments ({selectedLeadForComment.paymentPageComment.length})</Text>
                      <div style={{ 
                          maxHeight: '200px', 
                          overflowY: 'auto', 
                          marginTop: '8px',
                          padding: '8px',
                          background: '#f5f5f5',
                          borderRadius: '8px'
                      }}>
                          {[...selectedLeadForComment.paymentPageComment]
                              .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))
                              .map((comment, idx) => (
                                  <div key={idx} style={{ 
                                      marginBottom: '12px', 
                                      padding: '8px',
                                      background: 'white',
                                      borderRadius: '6px',
                                      border: '1px solid #e8e8e8'
                                  }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                          <Text type="secondary" style={{ fontSize: '11px' }}>
                                              <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                              {formatCommentDate(comment.changedAt)}
                                          </Text>
                                      </div>
                                      <Text style={{ fontSize: '13px' }}>{comment.comment}</Text>
                                  </div>
                              ))}
                      </div>
                  </div>
              )}
          </div>
      </Modal>
{/* Service Agent Assignment Modal */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <TeamOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Assign Service Agent</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Select service agent for this lead
                </Text>
            </div>
        </div>
    }
    open={serviceAgentModalVisible}
    onCancel={() => {
        setServiceAgentModalVisible(false);
        setSelectedLeadForServiceAgent(null);
        setSelectedServiceAgentForLead(null);
    }}
    footer={null}
    width={500}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForServiceAgent && (
            <>
                {/* Customer Info Card */}
                <Card 
                    size="small" 
                    style={{ 
                        marginBottom: 20,
                        background: '#f5f5f5',
                        borderRadius: 12,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                        <Text strong>
                            {selectedLeadForServiceAgent.personalInfo?.fullName || 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {selectedLeadForServiceAgent.vehicleInfo?.make} {selectedLeadForServiceAgent.vehicleInfo?.model} - {selectedLeadForServiceAgent.vehicleInfo?.part}
                        </Text>
                        {selectedLeadForServiceAgent.orderServiceHandledBy && (
                            <div style={{ 
                                marginTop: 8,
                                paddingTop: 8,
                                borderTop: '1px solid #e8e8e8'
                            }}>
                                <Text type="secondary" style={{ fontSize: 11 }}>
                                    Currently assigned: 
                                </Text>
                                <Text strong style={{ fontSize: 12, color: '#52c41a', marginLeft: 8 }}>
                                    {getServiceAgentName(selectedLeadForServiceAgent)}
                                </Text>
                            </div>
                        )}
                    </Space>
                </Card>

                {/* Service Agent Selection */}
                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Select Service Agent:
                    </Text>
                    <Select
                        value={selectedServiceAgentForLead}
                        onChange={setSelectedServiceAgentForLead}
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="Choose an agent"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        loading={loadingServiceAgents}
                    >
                        {Object.entries(serviceAgentsMap).map(([agentId, agentInfo]) => (
                            <Option key={agentId} value={agentId}>
                                <Space direction="vertical" size={0}>
                                    <Text strong>{agentInfo.name}</Text>
                                  
                                </Space>
                            </Option>
                        ))}
                    </Select>
                    <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                        {selectedServiceAgentForLead ? 'Agent will be assigned to this lead' : 'Clear to unassign the current agent'}
                    </Text>
                </div>

                {/* Modal Actions */}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                    <Button 
                        onClick={() => {
                            setServiceAgentModalVisible(false);
                            setSelectedLeadForServiceAgent(null);
                            setSelectedServiceAgentForLead(null);
                        }} 
                        size="large"
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="primary" 
                        onClick={handleServiceAgentSave}
                        loading={savingServiceAgent}
                        size="large"
                        icon={<CheckOutlined />}
                    >
                        {selectedServiceAgentForLead ? 'Assign Agent' : 'Unassign Agent'}
                    </Button>
                </div>
            </>
        )}
    </div>
</Modal>

{selectedLeadForYard && (
    <YardModal
        visible={yardModalVisible}
        onCancel={handleYardModalClose}
        onOk={handleYardModalSuccess}
        lead={selectedLeadForYard}
    />
)}

<YardReassignmentHistoryModal
    open={!!yardHistoryLead}
    onClose={() => setYardHistoryLead(null)}
    history={yardHistoryLead?.yardReassignmentHistory}
    leadId={yardHistoryLead?._id}
    yards={yardHistoryLead?.yard}
    yardDetailsMap={yardDetailsMap}
    leadName={yardHistoryLead?.personalInfo?.fullName}
    orderNumber={yardHistoryLead?.orderNumber}
    onNotesChanged={() => fetchLeads(true)}
/>

    </div>
  );
};

export default OrderComplete;
